import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';

/**
 * Route-level auth safety net.
 *
 * Reads the session token the login flow stores under `localStorage.user`
 * ({ user: { ...fields, token }, token } — either shape may carry the token).
 * When no valid session is present, redirects to /login instead of letting a
 * page render against an empty company id. Existing per-page checks stay in
 * place; this is the belt-and-suspenders wrapper.
 */
function hasValidSession(): boolean {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    const token = parsed?.token || parsed?.user?.token;
    return !!token;
  } catch {
    return false;
  }
}

interface ProtectedRouteProps {
  children: ReactElement;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactElement =>
  hasValidSession() ? children : <Navigate to="/login" replace />;
